import { useMutation } from '@tanstack/react-query'

import { issueChallenge } from '@src/api'
import { DefaultApiIssueChallengeRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useIssueChallenge = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiIssueChallengeRequest) =>
      issueChallenge(axiosInstance, params),
  })
}
